import { html, LitElement } from "lit-element";
import { style } from "./style";

class UserCircleImage extends LitElement {
	render() {
		let template;
		if (this.image) {
			template = html`
				<span class="image" style="background-image: url('${this.image}')"></span>
			`;
		} else {
			template = html`
				${this.initials(this.firstName, this.surname)}
			`;
		}
		return html`
			${template}
		`;
	}

	static get styles() {
		return [style];
	}

	static get properties() {
		return {
			image: String,
			firstName: String,
			surname: String
		};
	}

	initials(x, y) {
		if (x && y) {
			return x.charAt(0) + y.charAt(0);
		} else {
			return "U";
		}
	}
}

window.customElements.define("user-circle-image", UserCircleImage);
